// Variant selector. Renders one button per non-"before" variant in the current room.
// Highlights the currently-selected variant.

import type { Room, Variant } from '../app/types';
import { visibleVariants } from '../app/variantFilters';

export type VariantSelectHandler = (variant: Variant) => void;

export class VariantPanel {
  private readonly root: HTMLElement;
  private currentRoom: Room | null = null;
  private currentVariantId: string | null = null;
  private handler: VariantSelectHandler = () => {};

  constructor() {
    const el = document.getElementById('variant-panel');
    if (!el) throw new Error('[variantPanel] #variant-panel missing');
    this.root = el;
  }

  onSelect(handler: VariantSelectHandler): void {
    this.handler = handler;
  }

  setRoom(room: Room, currentVariantId: string): void {
    this.currentRoom = room;
    this.currentVariantId = currentVariantId;
    this.render();
  }

  setActiveVariant(variantId: string): void {
    this.currentVariantId = variantId;
    this.render();
  }

  private render(): void {
    if (!this.currentRoom) {
      this.root.innerHTML = '';
      return;
    }
    const room = this.currentRoom;
    this.root.innerHTML = '';
    // Filter rules live in variantFilters so the VR menu and voice commands
    // cannot disagree with this list about what a buyer may see.
    for (const variant of visibleVariants(room)) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.role = 'tab';
      btn.textContent = variant.name;
      btn.setAttribute('aria-selected', String(variant.id === this.currentVariantId));
      btn.dataset.variantId = variant.id;
      btn.addEventListener('click', () => this.handler(variant));
      this.root.appendChild(btn);
    }
  }
}
